export const generateRandomString = (length = 64) => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  return result;
};

export const toLocalDatetimeString = (date: Date) => {
  const pad = (n: number) => n.toString().padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const parseDatetimeLocalToUTC = (localDateStr: string): Date => {
  const date = new Date(localDateStr);
  date.setMinutes(date.getMinutes() - date.getTimezoneOffset()); // offset về UTC
  return date;
};

export function formatDateISO(date: Date): string {
  const utcDate = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()),
  );
  return utcDate.toISOString();
}

export function timeAgo(input: string | Date): string {
  const now = new Date();
  const date = input instanceof Date ? input : new Date(input);

  if (isNaN(date.getTime())) return "";

  const diffMs = now.getTime() - date.getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);

  if (diffSec < 60) {
    return "vài giây trước";
  }

  if (diffMin < 60) {
    return `${diffMin} phút trước`;
  }

  if (diffHour < 24) {
    return `${diffHour} giờ trước`;
  }

  if (diffDay <= 2) {
    return `${diffDay} ngày trước`;
  }

  const pad = (n: number): string => n.toString().padStart(2, "0");

  return (
    `${pad(date.getHours())}:${pad(date.getMinutes())} ` +
    `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
  );
}

export const detectType = (value: any): "date" | "number" | "string" => {
  if (value === null || value === undefined) return "string";

  if (typeof value === "number" && !isNaN(value)) return "number";

  if (typeof value === "string") {
    const trimmed = value.trim();

    if (trimmed === "") return "string";

    const isISOFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(trimmed);

    if (isISOFormat) {
      const time = Date.parse(trimmed);
      if (!isNaN(time)) return "date";
    }

    if (!isNaN(Number(trimmed))) return "number";
  }

  return "string";
};
